<template>
  <ReviewForm />
</template>

<script>
import ReviewForm from '@/layouts/components/form/ReviewForm.vue'

export default {
  components: { ReviewForm },
}
</script>
